export default __webpack_public_path__ + "static/media/coinix@3x.04558301.png";